import { isDefined } from '@sgme/fp';
import classNames from 'classnames';
import type { BackTestProps } from 'components/common-form/sidePanel/backTest/BackTest.connect';
import { QuoteLabel } from 'components/common-form/sidePanel/backTest/QuoteLabel';
import { INITIAL_QUOTE_LABEL, SECOND_QUOTE_LABEL } from 'components/common-form/sidePanel/backTest/shared';
import { CopyAllButtonByExcelGenerator } from 'components/shared/CopyAllButton/CopyAllButton';
import { FormattedValue } from 'components/shared/ReadOnlyGrid/FormattedValue';
import { useCallback } from 'react';

export type StatisticsProps = Pick<
  BackTestProps,
  | 'statistics'
  | 'quoteIds'
  | 'quoteLabels'
  | 'precision'
  | 'errors'
  | 'hasErrorForInitialQuoteId'
  | 'hasErrorForSecondQuoteId'
> & {
  className: string;
};
export function Statistics({
  statistics,
  quoteIds,
  quoteLabels,
  precision,
  className,
  hasErrorForInitialQuoteId,
  hasErrorForSecondQuoteId,
}: StatisticsProps) {
  const generateExcel = useCallback(() => {
    return [[undefined, ...Object.values(quoteIds)], ...Object.keys(statistics).map(k => [k, ...statistics[k]])];
  }, [statistics, quoteIds]);

  return (
    <div className="d-flex justify-content-end flex-wrap">
      <table className={classNames(className, 'table ')}>
        <tbody>
          <tr>
            <td />
            <td>
              {!hasErrorForInitialQuoteId && (
                <QuoteLabel
                  className="mx-auto"
                  color="primary"
                  label={quoteLabels.initialQuoteLabel}
                  shortLabel={INITIAL_QUOTE_LABEL}
                />
              )}
            </td>

            <td>
              {isDefined(quoteIds.secondQuoteId) && !hasErrorForSecondQuoteId && (
                <QuoteLabel
                  className="mx-auto"
                  color="danger"
                  label={quoteLabels.secondQuoteLabel}
                  shortLabel={SECOND_QUOTE_LABEL}
                />
              )}
            </td>
          </tr>
          {Object.keys(statistics).map(k => (
            <tr key={k}>
              <td className="w-100">{k}</td>
              {statistics[k].map((v, i) => (
                <td key={`${k}-${i}`} className="text-center">
                  <FormattedValue value={v} precision={precision} />
                  {v && '%'}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <CopyAllButtonByExcelGenerator generateExcelGrid={generateExcel} />
    </div>
  );
}
